<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('customer.orders.title') }}
        </h2>
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader :type="'_invert'"></emd-loader>
      </div>
      <div
        v-else
        class="emd-table-responsive"
      >
        <Table
          :fields="fields"
          :items="orders.items"
          :toDetail="permissionIsEnabled('order:get') && toDetail"
        ></Table>
        <empty-list
          v-if="!loadingList && showEmptyList()"
          entity="orders"
        ></empty-list>
      </div>
      <pagination
        v-if="!loadingList"
        :pagination="orders.pagination"
        :totalShowing="totalItems"
        :type="'list'"
        :action="action"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import Table from '@/components/project/molecules/Table.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'CustomerOrders',
  components: {
    EmdLoader,
    EmptyList,
    Pagination,
    Table
  },
  data () {
    return {
      action: 'GET_ORDERS',
      fields: [
        {
          id: 'code',
          label: 'customer.orders.code',
          type: 'text'
        },
        {
          id: 'amount',
          label: 'customer.orders.amount',
          type: 'text'
        },
        {
          id: 'status',
          label: 'customer.orders.status',
          type: 'status'
        },
        {
          id: 'created_at',
          label: 'customer.orders.created-at',
          type: 'date',
          format: 'dateAndHour'
        }
      ],
      toDetail: {
        name: 'ordersDetail',
        params: {
          id: 'id'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'merchant',
      'account',
      'orders',
      'loadingListOrders',
      'permissionIsEnabled'
    ]),
    totalItems () {
      return this.orders.items.length
    },
    loadingList () {
      return this.loadingListOrders
    }
  },
  methods: {
    showEmptyList () {
      return (
        !this.loadingList &&
        this.orders.pagination &&
        this.orders.pagination.total_items === 0
      )
    }
  },
  created () {
    const query = {
      customer_ids: this.$route.params.id,
      page: this.$route.query.page || 1,
      sort_mode: this.$route.query.sort_mode || 'DESC'
    }
    const params = {
      merchantId: this.merchant.id,
      accountId: this.account.id,
      query
    }
    this.$router.replace({ query: query }).catch(err => err)
    this.$store.dispatch('GET_ORDERS', params)
  }
}
</script>
